import { clsx } from "@trydig/ui";
import styles from "./RadioFieldset.module.css";

interface Option {
	label: string;
	value: string;
	subtitle?: string;
	disabled?: boolean;
	isMagazine?: boolean;
}

export const RadioFieldset = ({
	legend,
	name,
	options,
	large = false,
	state,
}: {
	legend?: string;
	name: string;
	large?: boolean;
	options: Option[];
	state?: {
		value: string;
		set: (value: {
			target: {
				value: string;
			};
		}) => void;
	};
}) => {
	return (
		<div className={large ? styles["fieldset-large"] : styles.fieldset}>
			{legend && <span className={styles.legend}>{legend}</span>}
			<div className={styles["radio-buttons"]}>
				{options.map((option, i) => (
					<div
						key={`${i}-option-radios`}
						className={clsx(
							large ? "radio-large" : "radio-small",
							"radio-wrap",
							option.disabled && styles.disabled,
						)}
					>
						<input
							type="radio"
							id={`${name}-${option.value}`}
							name={name}
							onChange={state?.set}
							disabled={option.disabled}
							value={option.value}
							checked={state?.value === option.value}
						/>
						<label htmlFor={`${name}-${option.value}`}>
							<span>
								{option.label}
								{option.subtitle && <span>{option.subtitle}</span>}
							</span>
						</label>
					</div>
				))}
			</div>
		</div>
	);
};
